import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";

import { AccessRules, rulesAreAvailable } from "../../helpers/userroles";
import { AuthService } from "../../services/authservice";

const NONPRODUCT_ROUTES = [
  ["/cert", "cert"],
  ["/ip-prefixes", "IP_PREFIX"],
  ["/support", "support"],
  ["/storing-en-onderhoud", "maintenance"],
  ["/notification-settings", "notification_settings"],
  ["/domains", "domains"],
];

const rulesIdentifierForPath = (path: string): string | null =>
  NONPRODUCT_ROUTES.find(([route]) => path.startsWith(route))?.[1] ?? null;

@Injectable({
  providedIn: "root",
})
export class AuthGuard {
  private auth = inject(AuthService);
  private router = inject(Router);

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<true | UrlTree> {
    let productType = route.paramMap.get("productType");
    const rules: string[] = [];

    if (!productType) {
      // attempt to get the rules identifier another way
      productType = rulesIdentifierForPath(state.url);
    }

    if (productType && rulesAreAvailable(productType)) {
      rules.push(...AccessRules[productType].view, ...AccessRules[productType].edit);
    }

    // wait for the auth service to load the userdata.
    // on a page reload this guard is called too soon,
    // so it always redirects to the dashboard even though
    // the user has access.
    return new Promise<true | UrlTree>(async (resolve) => {
      // no rules present for this route
      if (!rules.length) {
        resolve(true);
        return;
      }

      await this.auth.__waaait();

      // @ts-expect-error: There is a null/undefined issue; please fix me!
      const roleCheckResult = this.auth.checkRoleAccess(productType, "view");
      if (roleCheckResult.ok) {
        resolve(true);
      } else {
        this.auth.roleEvent.emit(roleCheckResult);
        resolve(this.router.parseUrl("/forbidden"));
      }
    });
  }
}
